import { Form } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { useEffect, useState } from 'react';
import debounce from "just-debounce-it";
import { useContextReports } from '../../../../../context/reports';
import { useContextUsers } from '../../../../../context/users';
import ReportSection from '../Section';
import RichTextEditor from '../../../../Common/RichTextEditor';
import './style.less';

interface IWelcomeMessage {
  isActive: boolean;
}

const WelcomeText = ({ isActive }: IWelcomeMessage) => {
  const name = 'welcome_message'
  const form = useFormInstance();
  const { profile } = useContextUsers();
  const { report, isBorrower, handleReportUpdate } = useContextReports();
  const [isDisabled, setIsDesabled] = useState<boolean>(true);
  const [htmlContent, setHtmlContent] = useState<string | null | undefined>();

  useEffect(() => {
    if (!profile && !report) return;
    setHtmlContent(report?.welcome_message);
    setIsDesabled(false);

    if (report?.name) {
      setIsDesabled(false);
    }
  }, [profile, report]);

  const debouncedHandleReportUpdate = debounce(() => {
    handleReportUpdate?.();
  }, 500);

  const handleEditorChange = (content: string) => {
    setHtmlContent(content);
    form.setFieldValue(['report', 'welcome_message'], content);
    debouncedHandleReportUpdate();
  };

  if ((isBorrower && htmlContent === '<p><br></p>') || (!isActive && isBorrower)) {
    return null;
  }

  return (
    <ReportSection
      show={isBorrower && isActive}
      name={name}
      title={!isBorrower ? 'Welcome Message' : ''}>
      <div id={name} className="flex-col gap-8">
        {isBorrower ? (
          <div className="custom-quill-editor-readonly">
            <RichTextEditor value={htmlContent || ''} readOnly hideToolbar />
          </div>
        ) : (
          <Form.Item name={['report', 'welcome_message']} label={!isBorrower ? 'Enter Text' : undefined} noStyle>
            <div className="custom-quill-editor">
              <RichTextEditor
                value={htmlContent || ''}
                onChange={handleEditorChange}
                placeholder="Enter welcome text"
                readOnly={isDisabled}
              />
            </div>
          </Form.Item>
        )}
      </div>
    </ReportSection>
  );
};

WelcomeText.defaultProps = {
  provided: undefined,
};

export default WelcomeText;
